<div class="container-fluid">
  <div class="row">
    <div class="col-md-12" *ngIf="isLoading">
      <app-busy [message]="message"></app-busy>
    </div>
    <div class="col-12">

      <!-- GENERAL -->
      <div class="card border-light shadow-sm">
        <label class="sb-txt"><span style="color: blue;">General</span></label>
        <div class="row">
          <div class="col-12">
            <table class="table borderless">
              <tbody>
                  <tr>
                    <td class="">
                      <b class="td-in">Account Number:</b><span class="m-cont text-primary">{{caConfirmObj.carrier_code}}</span>
                    </td>
                    <td>
                      <b>Account ID:<span style="color: red;"> {{carrierAccountObj.carrier_account_id}}</span></b>
                    </td>
                    <td>
                      <b>Account Status:<span style="color: red;"> {{caConfirmObj.carrier_status}}</span></b>
                    </td>
                  </tr>
                  <tr>
                    <td class="s-td">
                      <b class="td-in">Registered By:</b><span class="m-cont text-primary">{{caConfirmObj.lead_user?.first_name}}&nbsp;{{caConfirmObj.lead_user?.last_name}}</span>
                    </td>
                    <td>
                      <b>Account Balance:<span style="color: red;"> {{caConfirmObj.account_balance ? (caConfirmObj.account_balance | currencyFormat) : 'R0.00'}}</span></b>
                    </td>
                    <td>
                     </td>
                    <!-- <td class="s-td">
                    <b>Account Status:<span style="color: red;"> {{caConfirmObj.carrier_status}}</span></b>
                    </td> -->
                    <!-- <td class="s-td">
                       <b class="td-in">First Name:</b><span class="m-cont text-primary">{{caConfirmObj.lead_user?.first_name}}</span>
                    </td>
                    <td class="s-td">
                      <b class="td-in">Last Name:</b><span class="m-cont text-primary">{{caConfirmObj.lead_user?.last_name}}</span>
                    </td> -->
                  </tr>
                  <br>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- CARRIER ACCOUNT -->
      <div class="card border-light shadow-sm">
        <label class="sb-txt"><span style="color: blue;">Carrier Account</span></label>
        <!-- <label class="sb-txt" *ngIf="caConfirmObj.carrier_type_ind==6"><u></u></label> -->
        <label class="sb-txt" ></label>
        <div class="row">
          <div class="col-12">
            <table class="table borderless">
 
              <tbody>

                <tr>
                  <!--1st row-->
                  <td class="s-td">
                    <b>Customer Type:</b><span class="m-cont text-primary">{{caConfirmObj.carrier_type}}</span>
                  </td>
                  <td class="s-td">
                    <b>Country:</b><span class="m-cont text-primary">{{caConfirmObj.country}}</span>
                  </td>
                </tr>

                <tr>
                  <!--2nd row-->
                  <td *ngIf="caConfirmObj.carrier_type_ind!=1 && caConfirmObj.carrier_type_ind!=2" class="s-td">
                    <b>Company Reg Name:</b><span class="m-cont text-primary">{{caConfirmObj.registered_name}}</span>
                  </td>
                  <td *ngIf="caConfirmObj.carrier_type_ind==1 || caConfirmObj.carrier_type_ind==2" class="s-td">
                    <b class="td-in">Name:</b><span class="m-cont text-primary">{{caConfirmObj.owner?.first_name}}&nbsp;{{caConfirmObj.owner?.last_name}}</span>
                  </td>
                  <td *ngIf="caConfirmObj.carrier_type_ind!=1 && caConfirmObj.carrier_type_ind!=2" class="s-td" class="s-td">
                    <b>Trading Name:</b><span class="m-cont text-primary"> {{caConfirmObj.trading_name}}</span>
                  </td>
                  <td *ngIf="caConfirmObj.carrier_type_ind==1" class="s-td">
                    <b>ID Number:</b><span class="m-cont text-primary">{{caConfirmObj.registration_number}}</span>
                  </td>
                  <td *ngIf="caConfirmObj.carrier_type_ind==2" class="s-td">
                    <b>Passport / ID Number:</b><span class="m-cont text-primary">{{caConfirmObj.registration_number}}</span>
                  </td>
                </tr>

                <tr *ngIf="caConfirmObj.carrier_type_ind!=1 && caConfirmObj.carrier_type_ind!=2">
                  <!--3rd row-->
                  <td *ngIf="caConfirmObj.carrier_type_ind==6" class="s-td">
                    <b>Closed Corporation Reg No:</b><span class="m-cont text-primary">{{caConfirmObj.registration_number}}</span>
                  </td>
                  <td *ngIf="caConfirmObj.carrier_type_ind==7" class="s-td">
                    <b>Trust Reg No:</b><span class="m-cont text-primary">{{caConfirmObj.registration_number}}</span>
                  </td>
                  <td *ngIf="caConfirmObj.carrier_type_ind==8" class="s-td">
                    <b>ID Number of Main Partner:</b><span class="m-cont text-primary">{{caConfirmObj.registration_number}}</span>
                  </td>
                  <td *ngIf="caConfirmObj.carrier_type_ind!=6 &&
                             caConfirmObj.carrier_type_ind!=1 &&
                             caConfirmObj.carrier_type_ind!=2 &&
                             caConfirmObj.carrier_type_ind!=7 &&
                             caConfirmObj.carrier_type_ind!=8" class="s-td">
                             <b>Company Reg No:</b>
                             <span class="m-cont text-primary">
                               {{caConfirmObj.registration_number.length > 20 ? caConfirmObj.registration_number.slice(0, 20) : caConfirmObj.registration_number}}
                             </span>
                  </td>
                  <!-- <td>
                    <b class="td-in">Type of Business:</b><span class="m-cont text-primary">
                      <ng-container *ngFor="let list of utility.businessTypes">
                        <span *ngIf="list.key==caConfirmObj.business_type_ind">{{list.value}}</span>
                      </ng-container>
                    </span>
                  </td> -->
                </tr>

                <tr *ngIf="caConfirmObj.carrier_type_ind==2">
                  <td class="s-td">
                    <b class="td-in">Passport Country-of-Issue:</b><span class="m-cont text-primary">{{caConfirmObj.country}}</span>
                  </td>
                  <td class="s-td">
                    <b class="td-in">Passport Expiry Date:</b><span class="m-cont text-primary">{{caConfirmObj.owner?.passport_expiry_date | date:'dd/MM/yyyy'}}</span>
                  </td>
                </tr>

                <tr *ngIf="caConfirmObj.carrier_type_ind==2">
                  <td class="s-td">
                    <b class="td-in">Traffic Register Number (TRN):</b><span class="m-cont text-primary">{{caConfirmObj.owner?.traffic_register_number}}</span>
                  </td>
                  <td class="s-td">
                    <b class="td-in">Work Permit Reference Number:</b><span class="m-cont text-primary">{{caConfirmObj.owner?.work_permit_number}}</span>
                  </td>
                </tr>

                <tr *ngIf="caConfirmObj.carrier_type_ind==2">
                  <td class="s-td">
                    <b class="td-in">TRN Date-of-Issue:</b><span class="m-cont text-primary">{{caConfirmObj.owner?.trn_issue_date | date:'dd/MM/yyyy'}}</span>
                  </td>
                  <td class="s-td">
                    <b class="td-in">Work Permit Expiry Date:</b><span class="m-cont text-primary">{{caConfirmObj.owner?.work_permit_expiry_date | date:'dd/MM/yyyy'}}</span>
                  </td>
                </tr>

                <tr>
                  <td class="s-td">
                    <b class="td-in">Type of Carrier:</b><span class="m-cont text-primary">
                      <ng-container *ngFor="let list of utility.freight_passenger_inds">
                        <span *ngIf="list.key==caConfirmObj.freight_passenger_ind">{{list.value}}</span>
                        </ng-container>
                    </span>
                  </td>
                  <td class="s-td">
                    <b>Email Address:</b><span  class="m-cont text-primary">{{caConfirmObj.email}}</span>
                  </td>
                </tr>

                <tr>
                  <td class="s-td">
                    <b>Mobile Number:</b><span class="m-cont text-primary">{{caConfirmObj.dial_code_mobile}}&nbsp;{{caConfirmObj.mobile}}</span>
                  </td>
                  <td class="s-td">
                    <b>Office Number:</b><span class="m-cont text-primary">{{caConfirmObj.dial_code_office_phone}}&nbsp;{{caConfirmObj.office_phone}}</span>
                  </td>
                </tr>

              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTACT DETAILS -->
    <div class="col-12">
      <div class="card border-light shadow-sm">
        <label class="sb-txt"><span style="color: blue;">Contact Details</span></label>
        <div class="row">
          <div class="col-12">
            <table class="table borderless">
              <tbody>
                <tr>
                  <td class=""><b>Contact Person</b></td>
                  <td class=""><b>Physical Address</b></td>
                  <td class=""><b>Postal Address</b></td>
                </tr>

                <tr style="margin:0px!important;padding:0px!important;height:10px!important;">
                  <td class="">
                    <b class="td-in">Name:</b><span class="m-cont text-primary">{{caConfirmObj.contact?.first_name}}&nbsp;{{caConfirmObj.contact?.last_name}}</span>
                  </td>
                  <td class="">
                    <b class="td-in">Address:</b><span class="m-cont text-primary">{{caConfirmObj.physical_address?.line_address_1}}</span>
                  </td>
                  <td class="">
                    <b class="td-in">Address:</b><span class="m-cont text-primary">{{caConfirmObj.postal_address?.line_address_1}}</span>
                  </td>
                </tr>

                <tr style="margin:0px!important;padding:0px!important;height:10px!important;">
                  <td class="">
                    <b class="td-in">Email Address:</b><span class="m-cont text-primary">{{caConfirmObj.contact?.email}}</span>
                  </td>
                  <td class="">
                    <!--<b class="td-in">Line 2:</b><span class="m-cont text-primary">{{caConfirmObj.physical_address?.line_address_2}}</span>-->
                    <b class="td-in">Town:</b><span class="m-cont text-primary">{{caConfirmObj.physical_address?.line_address_town}}</span>
                  </td>
                  <td class="">
                    <!--<b class="td-in">Line 2:</b><span class="m-cont text-primary">{{caConfirmObj.postal_address?.line_address_2}}</span>-->
                    <b class="td-in">Town:</b><span class="m-cont text-primary">{{caConfirmObj.postal_address?.line_address_town}}</span>
                  </td>
                </tr>

                <tr style="margin:0px!important;padding:0px!important;height:10px!important;">
                    <td class="">
                    <b class="td-in">Mobile Number:</b><span class="m-cont text-primary">{{caConfirmObj.contact?.dial_code_mobile}}&nbsp;{{caConfirmObj.contact?.mobile}}</span>
                  </td>
                  <td class="">
                    <!--<b class="td-in">Line 3:</b><span class="m-cont text-primary">{{caConfirmObj.physical_address?.line_address_3}}</span>-->
                    <b class="td-in">Postal Code:</b><span class="m-cont text-primary">{{caConfirmObj.physical_address?.line_post_code}}</span>
                  </td>
                  <td class="">
                    <!--<b class="td-in">Line 3:</b><span class="m-cont text-primary">{{caConfirmObj.postal_address?.line_address_3}}</span>-->
                    <b class="td-in">Postal Code:</b><span class="m-cont text-primary">{{caConfirmObj.postal_address?.line_post_code}}</span>
                  </td>
                </tr>

                <tr style="margin:0px!important;padding:0px!important;height:10px!important;">
                  <td class="">
                    <b class="td-in">Communication Preference:</b><span class="m-cont text-primary">{{caConfirmObj.contact?.comms_preference}}</span>
                  </td>
                  <td class="">
                    <!--<b class="td-in">Town:</b><span class="m-cont text-primary">{{caConfirmObj.physical_address?.line_address_town}}</span>-->
                  </td>
                  <td class="">
                    <!--<b class="td-in">Town:</b><span class="m-cont text-primary">{{caConfirmObj.postal_address?.line_address_town}}</span>-->
                  </td>
                </tr>

                <br>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- COMPLIANCE AND LEGAL -->
    <div class="col-12">
      <div class="card border-light shadow-sm">
        <label class="sb-txt"><span style="color: blue;">Compliance and Legal</span></label>
        <div class="row">
          <div class="col-6">
            <table class="table borderless">
              <tbody>

                <tr *ngIf="caConfirmObj.is_local==1">
                <!-- <tr *ngIf="caConfirmObj. !=''"> -->
                  <td class="">
                    <b class="td-in">Tax Number:</b><span class="m-cont text-primary">{{caConfirmObj.tax_number}}</span>
                  </td>
                </tr>

                <tr>
                  <td class="">
                    <b class="cl-wdt">Transport Association:</b><span class="m-cont text-primary">{{caConfirmObj.transport_assoc}}</span>
                  </td>
                </tr>

                <!-- <tr>
                  <td class="cl-wdt"><b>Transport Association</b></td>
                  <td class="cl-wdt"><b>Tax Number</b></td>
                  <td class="cl-wdt"><b>BBBEE Status</b></td>
                  </tr> -->
                <!-- <tr class="text-primary">
                  <td>{{caConfirmObj.transport_assoc}}</td>
                  <td>{{caConfirmObj.tax_number}}</td>
                  <td>{{caConfirmObj.bbbee_status}}</td>
                  </tr> -->

                 <br>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- DEMOGRAPHICS -->
    <!-- <div class="col-12" *ngIf="caConfirmObj.bbbee_status!=''"> -->
      <div class="col-12" *ngIf="caConfirmObj.is_local">
      <div class="card border-light shadow-sm">
        <label class="sb-txt"><span style="color: blue;">Demographics</span></label>
         <div class="row">
          <div class="col-12">
            <table class="table borderless">
              <tbody>

                <tr>
                  <td class="">
                    <b class="cl-wdt">BBBEE Status:</b><span class="m-cont text-primary">{{caConfirmObj.bbbee_status}}</span>
                  </td>
                  <td class="">
                    <b class="cl-wdt">BBBEE Certificate Expiry Date:</b><span class="m-cont text-primary">{{caConfirmObj.Demographic.BBBEE_cert_expiry_date | date : 'dd/MM/yyyy'}}</span>
                  </td>
                </tr>

                <tr>
                  <td class="">
                    <b class="cl-wdt">% Black Ownership:</b><span class="m-cont text-primary">{{caConfirmObj.Demographic.black_ownership_percentage}}</span>
                  </td>
                  <td class="">
                    <b class="cl-wdt">% Female Ownership:</b><span class="m-cont text-primary">{{caConfirmObj.Demographic.female_ownership_percentage}}</span>
                  </td>
                </tr>

                <tr>
                  <td class="">
                    <b class="cl-wdt">% Disability Ownership:</b><span class="m-cont text-primary">{{caConfirmObj.Demographic.disability_ownership_percentage}}</span>
                  </td>
                  <td class="">
                    <b class="cl-wdt">% Youth Ownership:</b><span class="m-cont text-primary">{{caConfirmObj.Demographic.youth_ownership_percentage}}</span>
                  </td>
                </tr>

                <tr>
                  <td class="">
                    <b class="cl-wdt">Turnover Brand:</b><span class="m-cont text-primary">{{turnOverBrand[caConfirmObj.Demographic['turnover_band']]}}</span>
                  </td>
                  <td class="">
                    <b class="cl-wdt">Number of Employees:</b><span class="m-cont text-primary">{{caConfirmObj.Demographic.number_of_employees}}</span>
                  </td>
                </tr>

                <!-- <tr>
                  <td class="cl-wdt"><b>BBBEE Status</b></td>
                  <td class="cl-wdt"><b>BBBEE Certificate Expiry Date</b></td>
                  <td class="cl-wdt"><b>% Black Ownership</b></td>
                </tr>
                <tr class="text-primary">
                  <td>{{caConfirmObj.bbbee_status}}</td>
                  <td>{{caConfirmObj.Demographic.BBBEE_cert_expiry_date | date : 'dd/MM/yyyy'}}</td>
                  <td>{{caConfirmObj.Demographic.black_ownership_percentage}}</td>
                </tr>
                <tr>
                  <td class="cl-wdt"><b>% Female Ownership</b></td>
                  <td class="cl-wdt"><b>% Disability Ownership</b></td>
                  <td class="cl-wdt"><b>% Youth Ownership</b></td>
                </tr>
                <tr class="text-primary">
                  <td>{{caConfirmObj.Demographic.female_ownership_percentage}}</td>
                  <td>{{caConfirmObj.Demographic.disability_ownership_percentage}}</td>
                  <td>{{caConfirmObj.Demographic.youth_ownership_percentage}}</td>
                </tr>
                <tr>
                  <td class="cl-wdt"><b>Turnover Brand</b></td>
                  <td class="cl-wdt"><b>Number of Employees</b></td>
                </tr>
                <tr class="text-primary">
                  <td>{{turnOverBrand[caConfirmObj.Demographic['turnover_band']]}}</td>
                  <td>{{caConfirmObj.Demographic.number_of_employees}}</td>
                </tr> -->

                <br>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- DOCUMENTS -->
    <div class="col-12">
      <div class="card">
        <label class="sb-txt"><span style="color: blue;">Documents Uploaded</span></label>
        <label class="sb-txt"><u></u></label>
        <div class="row">
          <div class="col-12">
            <table class="table borderless">
              <tbody>
                <tr>
                  <td style="text-align: left;"> <b>Document Type</b></td>
                  <td style="text-align: center;"><b>File Name</b></td>
                  <td style="text-align: center;" class="cl-wdt"><b>Uploaded On</b></td>
                  <td style="text-align: center;"><b>View File</b></td>
                  <td></td>
                </tr>
                <ng-container *ngIf="showDocs">
                  <tr class="text-primary" *ngFor="let doc of caConfirmObj?.documents">
                    <td style="text-align: left;">{{doc.docType}}</td>
                    <td style="text-align: center;">{{doc.desc}}</td>
                    <td style="text-align: center;">{{doc.uploadedOn|date : 'dd/MM/yyyy'}}</td>
                    <td style="text-align: center;"> 
                      <span  title="View Document " class="btn btn-success btn-sm"><i class="fa fa-eye"
                          aria-hidden="true" data-toggle="modal" data-target="#exampleModalLong"
                          (click)="viewDoc(doc.document_link)"></i></span>
                    </td>
                  </tr>
                  <tr *ngIf=" caConfirmObj?.documents.length==0">
                    <td colspan="4" style="text-align:center">(No documents)</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="card border-light shadow-sm" *ngIf="!ctrlData.isApproval">
        <!-- <label class="sb-txt">Carrier account declaration</label> - -->
        <div class="row">
          <div class="col-12">
            <table class="table borderless">
              <tbody>
                <!-- <tr class="text-primary">
                  <td><strong>{{caConfirmObj.registered_name}}</strong></td>
                  <td><strong>{{caConfirmObj.registration_number}}</strong></td>
                  <td><strong>{{caConfirmObj.country}}</strong></td>
                </tr>
                 -->
                <tr>
                  <td colspan="3" [innerHTML]="declaration"></td>
                </tr>
                <tr>
                  <td class="text-primary" colspan="3" style="font-size:12px;">Declaration by
                    <strong>{{userInfo.username}}</strong> on <strong>{{decl_date|date : 'yyyy/MM/dd'}}</strong></td>
                </tr>
                <tr>
                  <td colspan="3" style="margin:0px;padding:0px;">
                    <form class="frm-top col-12" [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
                      <label class="form-inline text-primary" style="margin:0px;padding:0px;">
                        <input class="form-control input-sm" type="checkbox" id="uAgreed" name="uAgreed"
                          formControlName="uAgreed">
                        <strong style="font-size:12px;">&nbsp; By checking the box, you declare that the information given above and in the enclosed documents is true</strong>
                      </label>
                    </form>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12" *ngIf="utility.isBtnVisible">
      <button *ngIf="ctrlData.xstatus != 1 && !utility.isCarrier" title="Submit your carrier account's details"
        (click)="onSubmit(form.value)" type="submit" id="btnSave" class="btn btn-md m-clr pull-right hd-btn"
        style="width:auto; margin-right:0px;margin-bottom:5px;  ">Submit</button>
      <button *ngIf="utility.isView && !utility.isCarrier && ctrlData.xstatus != 1" title="Previous tab"
        (click)="back()" type="submit" id="btnSave" class="btn btn-md m-clr pull-left hd-btn"
        style="width:auto; margin-right:4px;margin-bottom:5px;  ">Back</button>
      <button *ngIf="utility.isView && !utility.isCarrier" title="Cancel" (click)="utility.landingPage()" type="submit"
        id="btnSave" class="btn btn-md m-clr pull-right hd-btn"
        style="width:auto; margin-right:4px;margin-bottom:5px;  ">Cancel</button>
      <button *ngIf="utility.isCarrier" title="Cancel" (click)="utility.landingPage()" type="submit" id="btnSave"
        class="btn btn-md m-clr pull-right hd-btn"
        style="width:auto; margin-right:4px;margin-bottom:5px;  ">Back</button>

    </div>
  </div>
</div>

<div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
  aria-hidden="true" >
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Document Uploaded</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-lg">
        <div style="width: 99%; height: 600px;">
        <img *ngIf="isPDF==2" [src]="doc" width="780" />
        <!-- <pdf-viewer *ngIf="isPDF==1" [src]="doc" [render-text]="true" style="display: block;"
        [original-size]="false"
        [autoresize]="true"
        ></pdf-viewer> -->
        <ng2-pdfjs-viewer *ngIf="isPDF==1" [pdfSrc]='doc'         
        id='view2'             
      [externalWindow]="false"
      [downloadFileName]="'mytestfile.pdf'"                  
      [openFile]="false"
      [viewBookmark]="false"
      [download]="false" >
    </ng2-pdfjs-viewer>
  </div>
        <ngx-loading [show]="isLoadingImg"></ngx-loading>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" data-dismiss="modal">Close</button>
        <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
      </div>
    </div>
  </div>
</div>
